<template>
  <div
    v-if="show"
    class="div-componenteUCPrecarga"
    data-testid="ucpreload-main-div"
  >
    <div
      v-for="index in number"
      :key="index"
      data-testid="ucpreload-loader-div"
    >
      <div class="loader" />
      <br>
      <div class="loader" />
      <br>
      <div class="loader small" />
      <br>
    </div>
  </div>
</template>

<script setup>
// @ts-check
defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  // Número de elementos de precarga que se muestra
  number: {
    type: Number,
    default: 2,
  },
});
</script>

<style scoped>
.loader {
  background-color: #f4f2f2;
  height: 30px;
  position: relative;
  overflow: hidden;
  width: 100%;
}

.loader::after {
  content: "";
  position: absolute;
  height: 100%;
  width: 50%;
  background: #ece7e7;
  animation: progress 1.5s infinite linear;
}

.loader.small {
  width: 180px;
}

@keyframes progress {
  0% {
    left: 0;
    transform: translateX(-100%);
  }

  100% {
    left: 100%;
    transform: translateX(0%);
  }
}

.div-componenteUCPrecarga {
  margin: 5%;
}
</style>
